import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { Button, Descriptions, Result, Spin, Tag } from 'antd';
import CheckoutLayout from '../components/CheckoutLayout';
import { getPayment } from '../api/payment';
import { getDefaultMerchantName } from '../utils/site';
import { getCurrencyMeta } from '../constants/currency';

function formatAmount(amount, currency) {
  if (amount == null) return '-';
  const value = (Number(amount) / 100).toFixed(2);
  const { symbol } = getCurrencyMeta(currency);
  return `${symbol}${value}`;
}

export default function StatusPage() {
  const { gatewayOrderNo } = useParams();
  const [searchParams] = useSearchParams();
  const merchantOrderNo = searchParams.get('merchant_order_no');
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    getPayment(gatewayOrderNo, true)
      .then((res) => {
        if (res.code !== 0) {
          throw new Error(res.message || 'query failed');
        }
        setOrder(res.data);
        setError('');
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [gatewayOrderNo]);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <div className="checkout-loading">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <CheckoutLayout merchantName={getDefaultMerchantName()} logoText="PG">
        <Result
          status="error"
          title="Unable to load payment"
          subTitle={error}
          extra={[
            <Button key="retry" onClick={load}>Retry</Button>,
            <Link to="/pay" key="new"><Button type="primary" style={{ background: '#1a5c3a' }}>New payment</Button></Link>,
          ]}
        />
      </CheckoutLayout>
    );
  }

  return (
    <CheckoutLayout merchantName={getDefaultMerchantName()} logoText="PG">
      <Result
        status={order.status === 'SUCCESS' ? 'success' : 'info'}
        title={`Order ${order.status}`}
        subTitle={order.gateway_order_no}
        extra={[
          order.pay_url && order.status === 'PENDING' && (
            <Button key="pay" type="primary" href={order.pay_url} style={{ background: '#1a5c3a' }}>
              Continue payment
            </Button>
          ),
          <Button key="refresh" onClick={load}>Refresh</Button>,
          <Link to="/pay" key="new"><Button>New payment</Button></Link>,
        ].filter(Boolean)}
      />
      <Descriptions column={1} bordered size="small" style={{ marginTop: 24 }}>
        <Descriptions.Item label="Merchant order">{order.merchant_order_no || merchantOrderNo || '-'}</Descriptions.Item>
        <Descriptions.Item label="Channel order">{order.channel_order_no || '-'}</Descriptions.Item>
        <Descriptions.Item label="Amount">{formatAmount(order.amount, order.currency)}</Descriptions.Item>
        <Descriptions.Item label="Currency">{order.currency}</Descriptions.Item>
        <Descriptions.Item label="Status"><Tag>{order.status}</Tag></Descriptions.Item>
        {order.paid_at && <Descriptions.Item label="Paid at">{order.paid_at}</Descriptions.Item>}
      </Descriptions>
    </CheckoutLayout>
  );
}
